import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminTaskReports from './AdminTaskReports';
import AdminUserManagement from './AdminUserManagement';
import AdminOccultBank from './AdminOccultBank';
import AdminFeaturedTasks from './AdminFeaturedTasks';
import AdminTreasureHunt from './AdminTreasureHunt';
import AdminMapCreator from './AdminMapCreator';
import AdminMortgageRates from './AdminMortgageRates';
import './AdminTaskReports.css';
import './AdminPanel.css';

const AdminPanel = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('users');

  // Check if user is admin, if not redirect
  React.useEffect(() => {
    if (!user || user.role !== 'admin') {
      navigate('/');
    }
  }, [user, navigate]);

  return (
    <div className="admin-panel-container">
      <div className="admin-tabs">
        <button 
          className={`admin-tab-button ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          👥 User Management
        </button>
        <button 
          className={`admin-tab-button ${activeTab === 'reports' ? 'active' : ''}`}
          onClick={() => setActiveTab('reports')}
        >
          📊 Task Reports
        </button>
        <button 
          className={`admin-tab-button ${activeTab === 'community' ? 'active' : ''}`}
          onClick={() => setActiveTab('community')}
        >
          🏦 Occult Bank
        </button>
        <button 
          className={`admin-tab-button ${activeTab === 'featured' ? 'active' : ''}`}
          onClick={() => setActiveTab('featured')}
        >
          🌟 Featured Tasks
        </button>
        <button 
          className={`admin-tab-button ${activeTab === 'treasure' ? 'active' : ''}`}
          onClick={() => setActiveTab('treasure')}
        >
          🏴‍☠️ Treasure Hunt
        </button>
        <button 
          className={`admin-tab-button ${activeTab === 'create' ? 'active' : ''}`}
          onClick={() => setActiveTab('create')}
        >
          🏗️ Create
        </button>
        <button 
          className={`admin-tab-button ${activeTab === 'mortgage' ? 'active' : ''}`}
          onClick={() => setActiveTab('mortgage')}
        >
          🏦 Mortgage Rates
        </button>
      </div>

      <div className="admin-content">
        {activeTab === 'users' ? (
          <AdminUserManagement standalone={false} key="userManagement" />
        ) : activeTab === 'reports' ? (
          <AdminTaskReports standalone={false} />
        ) : activeTab === 'community' ? (
          <AdminOccultBank standalone={false} />
        ) : activeTab === 'featured' ? (
          <AdminFeaturedTasks standalone={false} />
        ) : activeTab === 'treasure' ? (
          <AdminTreasureHunt standalone={false} />
        ) : activeTab === 'create' ? (
          <AdminMapCreator standalone={false} />
        ) : activeTab === 'mortgage' ? (
          <AdminMortgageRates standalone={false} />
        ) : null}
      </div>
    </div>
  );
};

export default AdminPanel;